import React from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, Package } from "lucide-react";
import { formatPrice } from "@/lib/api";

export default function OrderConfirmation() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const order = state?.order;

  if (!order) {
    return (
      <div className="pt-40 pb-32 text-center min-h-screen">
        <p className="font-display text-3xl">No order found</p>
        <button onClick={() => navigate("/")} className="mt-6 border border-white/20 px-6 py-3 font-mono-th text-xs uppercase tracking-[0.2em]">Go home</button>
      </div>
    );
  }

  return (
    <div className="pt-32 pb-24 min-h-screen flex items-center" data-testid="order-confirmation-page">
      <div className="max-w-xl mx-auto px-5 md:px-10 w-full text-center">
        <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ type: "spring", damping: 12 }} className="w-20 h-20 rounded-full bg-emerald-500 flex items-center justify-center mx-auto mb-8">
          <Check className="w-10 h-10 text-black" strokeWidth={3} />
        </motion.div>
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }}>
          <p className="font-mono-th text-xs uppercase tracking-[0.3em] text-emerald-400 mb-4">Order Confirmed</p>
          <h1 className="font-display font-black uppercase text-4xl md:text-5xl tracking-tight">Thank you, {order.customerName.split(" ")[0]}.</h1>
          <p className="text-neutral-400 mt-4">Your THRIFTHOUSE order has been received. We'll reach out on <span className="text-white">{order.phone}</span> to confirm delivery.</p>

          <div className="glass p-6 mt-10 text-left" data-testid="confirmation-details">
            <div className="flex items-center justify-between border-b border-white/10 pb-4 mb-4">
              <span className="font-mono-th text-xs uppercase tracking-widest text-neutral-500">Order Number</span>
              <span className="font-mono-th text-sm" data-testid="confirmation-order-number">{order.orderNumber}</span>
            </div>
            <div className="space-y-3">
              {order.items.map((it, i) => (
                <div key={i} className="flex justify-between text-sm">
                  <span className="text-neutral-300">{it.name} <span className="text-neutral-500">×{it.quantity}</span></span>
                  <span>{formatPrice(it.price * it.quantity)}</span>
                </div>
              ))}
            </div>
            <div className="flex justify-between font-display font-bold text-lg pt-4 mt-4 border-t border-white/10">
              <span>Total</span><span>{formatPrice(order.total)}</span>
            </div>
            <div className="flex items-center gap-2 mt-4 text-neutral-400 text-xs">
              <Package className="w-4 h-4" /> Status: <span className="text-amber-400 uppercase font-mono-th">{order.status}</span>
            </div>
          </div>

          <Link to="/shop" className="inline-block mt-10 bg-white text-black px-8 py-4 font-mono-th text-xs uppercase tracking-[0.2em] font-semibold hover:bg-neutral-200 transition-colors" data-testid="continue-shopping-btn">
            Continue Shopping
          </Link>
        </motion.div>
      </div>
    </div>
  );
}
